/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, position: NonNullable<unknown>, count: NonNullable<unknown> }} Agenda_Journey_PillInputs */



/**
* | output |
* | --- |
* | "{name} · {position}/{count}" |
*
* @param {Agenda_Journey_PillInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_journey_pill = /** @type {((inputs: Agenda_Journey_PillInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_Journey_PillInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`${i?.name} · ${i?.position}/${i?.count}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.name} · ${i?.position}/${i?.count}`)
	return /** @type {LocalizedString} */ (`${i?.name} · ${i?.position}/${i?.count}`)
});